import { TextInput, SelectInput, PhoneNumberInput } from "components/form_new";
import useTranslate from "hooks/use-translate-language";
import { STATES } from "utils/enum";
import { useFormikContext } from "formik";

const EditPhysician = () => {
  const translate = useTranslate();
  const { values, errors } = useFormikContext();

  // Get physicians array from form values
  const physicians = values.physicians ?? [];

  return (
    <>
      <hr
        style={{
          margin: "5px",
          border: "none",
          borderTop: "2px solid #dee2e6"
        }}
      />

      <div className="profile-panel">
        {physicians.map((physician, index) => (
          <div key={physician.product_line}>
            <h2 style={{ marginBottom: 15, color: "#337abb" }}>
              {physician.product_line} {translate("physician")}
            </h2>
            <div className="profile-panel-content">
              <TextInput
                label={translate("physicianName")}
                name={`physicians.${index}.name`}
              />

              <PhoneNumberInput
                label={translate("phoneNumber")}
                name={`physicians.${index}.phone`}
                type="tel"
              />

              <PhoneNumberInput
                label={translate("fax")}
                name={`physicians.${index}.fax`}
                type="tel"
              />

              <TextInput label={translate("npi")} name={`physicians.${index}.npi`} />

              <TextInput
                label={translate("streetAddress")}
                name={`physicians.${index}.address.street_address`}
              />

              <TextInput
                label={translate("streetAddress2")}
                name={`physicians.${index}.address.street_address2`}
              />

              <TextInput
                label={translate("city")}
                name={`physicians.${index}.address.city`}
              />

              <SelectInput
                label={translate("state")}
                name={`physicians.${index}.address.state`}
                options={STATES}
              />

              <TextInput
                label={translate("zipCode")}
                name={`physicians.${index}.address.zip`}
              />
            </div>
          </div>
        ))}
      </div>
    </>
  );
};

export default EditPhysician;
